import { AuthDto } from './dtos/auth.dto';
import { axiosCore } from './http-core-service';

/**
 * Méthode d'appel au back pour la récupération du token de connexion
 *
 * @param auth
 */
export const login = async (auth: AuthDto) => {
    const data = { identifiant: auth.login, password: auth.password };
    const response = await axiosCore.post('/login', data);
    return response.data.token;
};

/**
 * Performs a logout by sending a GET request to the '/logout' endpoint.
 *
 * @async
 * @returns {Promise} A promise that resolves to the response data from the server.
 */
export const logout = async (): Promise<any> => {
    const response = await axiosCore.get('/logout');
    return response.data;
};
